export enum NavigationRoutes {
  GuestDashboardView = '/guest-dashboard',
  ApprovalItemsList = '/approvals',
  ApprovalItemsView = '/approvals/[id]',
  UpgradeList = '/upgrades',
  UpgradeCreate = '/upgrades/create',
  UpgradeView = '/upgrades/[id]',
  TourSalesList = '/tour-sales',
  TourSalesCreate = '/tour-sales/create',
  ToursalesView = '/tour-sales/[id]',
  TourList = '/tour',
  TourCreate = '/tour/create',
  TourView = '/tour/[id]',
  ProjectList = '/projects',
  ProjectCreate = '/projects/create',
  ProjectView = '/projects/[id]',
  CommissionList = '/commissions',
  CommissionCreate = '/commissions/create',
  CommissionView = '/commissions/[id]',
  TippingList = '/tippings',
  TippingCreate = '/tippings/create',
  TippingView = '/tippings/[id]',
  ChequeGiroClearingsList = '/cheque-giro-clearing',
  ChequeGiroClearingsCreate = '/cheque-giro-clearing/create',
  ChequeGiroClearingsView = '/cheque-giro-clearing/[id]',
  IncomeCostsList = '/income-and-costs',
  IncomeCostsCreate = '/income-and-costs/create',
  IncomeCostsView = '/income-and-costs/[id]',
  BalanceAdjustmentsList = '/balance-adjustments',
  BalanceAdjustmentsCreate = '/balance-adjustments/create',
  BalanceAdjustmentsView = '/balance-adjustments/[id]',
  TransfersList = '/transfers',
  TransfersCreate = '/transfers/create',
  TransfersView = '/transfers/[id]',
  CashTransactionsList = '/cash-transactions',
  CashTransactionsCreate = '/cash-transactions/create',
  CashTransactionsView = '/cash-transactions/[id]',
  BankTransactionsList = '/bank-transactions',
  BankTransactionsCreate = '/bank-transactions/create',
  BankTransactionsView = '/bank-transactions/[id]',
  OrderAdjustmentList = '/order-adjustments',
  OrderAdjustmentCreate = '/order-adjustments/create',
  OrderAdjustmentView = '/order-adjustments/[id]',
  TicketSalesList = '/ticket-sales',
  TicketSalesCreate = '/ticket-sales/create',
  TicketSalesView = '/ticket-sales/[id]',
  HotelSalesList = '/hotel-sales',
  HotelSalesCreate = '/hotel-sales/create',
  HotelSalesView = '/hotel-sales/[id]',
  CruiseSalesList = '/cruise-sales',
  CruiseSalesCreate = '/cruise-sales/create',
  CruiseSalesView = '/cruise-sales/[id]',
  ActivitySalesList = '/activity-sales',
  ActivitySalesCreate = '/activity-sales/create',
  ActivitySalesView = '/activity-sales/[id]',
  FlightPurchasesList = '/ticket-orders',
  FlightPurchasesCreate = '/ticket-orders/create',
  FlightPurchasesView = '/ticket-orders/[id]',
  TravelDocumentSalesList = '/travel-documents',
  TravelDocumentSalesCreate = '/travel-documents/create',
  TravelDocumentSalesView = '/travel-documents/[id]',
  HotelPurchasesList = '/hotel-purchases',
  HotelPurchasesCreate = '/hotel-purchases/create',
  HotelPurchasesView = '/hotel-purchases/[id]',
  CruisePurchasesList = '/cruise-purchases',
  CruisePurchasesCreate = '/cruise-purchases/create',
  CruisePurchasesView = '/cruise-purchases/[id]',
  DocumentPurchasesList = '/document-purchases',
  DocumentPurchasesCreate = '/document-purchases/create',
  DocumentPurchasesView = '/document-purchases/[id]',
  ActivityPurchasesList = '/activity-purchases',
  ActivityPurchasesCreate = '/activity-purchases/create',
  ActivityPurchasesView = '/activity-purchases/[id]',
  CostsList = '/costs',
  CostsCreate = '/costs/create',
  CostsView = '/costs/[id]',
  RevenuesList = '/revenues',
  RevenuesCreate = '/revenues/create',
  RevenuesView = '/revenues/[id]',
  PreferenceTagsList = '/preference-tags',
  PreferenceTagsCreate = '/preference-tags/create',
  PreferenceTagsView = '/preference-tags/[id]',
  EmployeesList = '/employees',
  EmployeesCreate = '/employees/create',
  EmployeesView = '/employees/[id]',
  RolesList = '/roles',
  RolesCreate = '/roles/create',
  RolesView = '/roles/[id]',
  CustomersList = '/customers',
  CustomersCreate = '/customers/create',
  CustomersView = '/customers/[id]',
  AgentsList = '/agents',
  AgentsCreate = '/agents/create',
  AgentsView = '/agents/[id]',
  GuestsList = '/guests',
  GuestsCreate = '/guests/create',
  GuestsView = '/guests/[id]',
  ApprovalMastersList = '/approval-masters',
  ApprovalMastersCreate = '/approval-masters/create',
  ApprovalMastersView = '/approval-masters/[id]',
  AirlinesList = '/airlines',
  AirlinesCreate = '/airlines/create',
  AirlinesView = '/airlines/[id]',
  HotelsList = '/hotels',
  HotelsCreate = '/hotels/create',
  HotelsView = '/hotels/[id]',
  CruisesList = '/cruises',
  CruisesCreate = '/cruises/create',
  CruisesView = '/cruises/[id]',
  ActivitiesList = '/activities',
  ActivitiesCreate = '/activities/create',
  ActivitiesView = '/activities/[id]',
  TourCategoryList = '/tour-categories',
  TourCategoryCreate = '/tour-categories/create',
  TourCategoryView = '/tour-categories/[id]',
  ChequeGirosList = '/cheque-giros',
  ChequeGirosCreate = '/cheque-giros/create',
  ChequeGirosView = '/cheque-giros/[id]',
  PaymentChannelsList = '/payment-channels',
  PaymentChannelsCreate = '/payment-channels/create',
  PaymentChannelsView = '/payment-channels/[id]',
  CashAccountsList = '/cash-accounts',
  CashAccountsCreate = '/cash-accounts/create',
  CashAccountsView = '/cash-accounts/[id]',
  BankAccountsList = '/bank-accounts',
  BankAccountsCreate = '/bank-accounts/create',
  BankAccountsView = '/bank-accounts/[id]',
  TransactionCategoriesList = '/transaction-categories',
  TransactionCategoriesCreate = '/transaction-categories/create',
  TransactionCategoriesView = '/transaction-categories/[id]',
  AccountPayablesList = '/account-payables',
  AccountPayablesCreate = '/account-payables/create',
  AccountPayablesView = '/account-payables/[id]',
  AccountReceivablesList = '/account-receivables',
  AccountReceivablesCreate = '/account-receivables/create',
  AccountReceivablesView = '/account-receivables/[id]',
  ReceiptsList = '/receipts',
  ReceiptsCreate = '/receipts/create',
  ReceiptsView = '/receipts/[id]',
  ProductsList = '/products',
  ProductsCreate = '/products/create',
  ProductsView = '/products/[id]',
  ProductSalesList = '/product-sales',
  ProductSalesCreate = '/product-sales/create',
  ProductSalesView = '/product-sales/[id]',
  ProductPurchasesList = '/product-purchases',
  ProductPurchasesCreate = '/product-purchases/create',
  ProductPurchasesView = '/product-purchases/[id]',
  ProductAdjustmentList = '/product-adjustment',
  ProductAdjustmentCreate = '/product-adjustment/create',
  ProductAdjustmentView = '/product-adjustment/[id]',
  RefundList = '/refunds',
  RefundCreate = '/refunds/create',
  RefundView = '/refunds/[id]',
  RefundReleaseAgentList = '/refund-release-agents',
  RefundReleaseAgentView = '/refund-release-agents/[id]',
  RefundReleaseUserList = '/refund-release-users',
  RefundReleaseUserView = '/refund-release-users/[id]',
  ChangePassword = '/change-password',
  Reschedule = '/reschedules',
  Cro = '/cro',
  VisaDocumentList = '/visa-document',
  VisaDocumentCreate = '/visa-document/create',
  VisaDocumentView = '/visa-document/[id]',
  BonusPeriodList = '/bonus-period',
  BonusPeriodCreate = '/bonus-period/create',
  BonusPeriodView = '/bonus-period/[id]',
  AccountReceivableReport = '/reports-account-receivable',
  AccountReceivableRegularReport = '/reports-account-receivable-regular',
  AccountPayableReport = '/reports-account-payable',
  AccountPayableRegularReport = '/reports-account-payable-regular',
  AgentMutationReport = '/reports-agent-mutation',
  BankMutationReport = '/reports-bank-mutation',
  CashMutationReport = '/reports-cash-mutation',
  CustomerMutationReport = '/reports-customer-mutation',
  FlightReport = '/reports-flight',
  HotelReport = '/reports-hotel',
  PurchaseReport = '/reports-purchase',
  SaleReport = '/reports-sale',
  TourReport = '/reports-tour',
  ProfitLossReport = '/reports-income-statement',
  TourDetailReport = '/reports.tour-detail-show',
  IncomeReport = '/reports-income',
  ProjectReport = '/reports-project',
  TransactionReport = '/transaction-report',
  EmployeeComissionReport = '/employee-commission-report',
  SalesBonusReport = '/sales-bonus-report',
  NonSalesBonusReport = '/non-sales-bonus-report',
  PassportReport = '/passport-report',
  VisaReport = '/visa-report',
  ApecCardReport = '/apec-card-report',
  InsuranceReport = '/insurance-report',
}
